import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Flex,
  Text,
  Button,
  HStack,
} from '@chakra-ui/react'

import { useState, useEffect } from 'react'
import { modal } from '../../themes/styles'
import TabItemComponent from '../TableItemComponent'
import ModalInput from '../forms/modalForms/modalInput'

interface FeedbackModalProps {
  isOpen: boolean
  onClose: () => void
  feedback: {
    correct_feedback: string
    incorrect_feedback: string
  }
  onFeedbackChange: (feedback: { correct_feedback: string; incorrect_feedback: string }) => void
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onClose, feedback, onFeedbackChange }) => {
  const [selectedTab, setSelectedTab] = useState('correctanswers')
  const [localFeedback, setLocalFeedback] = useState(feedback)

  useEffect(() => {
    setLocalFeedback(feedback)
  }, [feedback])

  const handleLocalChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { value } = e.target
    setLocalFeedback({
      ...localFeedback,
      [selectedTab === 'correctanswers' ? 'correct_feedback' : 'incorrect_feedback']: value,
    })
  }

  const handleSubmit = () => {
    onFeedbackChange(localFeedback)
    onClose()
  }

  const handleCancel = () => {
    setLocalFeedback(feedback)
    onClose()
  }

  const tabItems = [
    { title: 'Correct Answers', tab: 'correctanswers' },
    { title: 'Incorrect Answers', tab: 'incorrectanswers' },
  ]

  return (
    <Modal isOpen={isOpen} onClose={handleCancel} isCentered>
      <ModalOverlay />
      <ModalContent mx="0px" borderRadius="10px" maxWidth="520px">
        <ModalBody p="0" h="248px">
          <Flex
            direction="row"
            w="100%"
            px="16px"
            py="12px"
            h="100%"
            justify="space-between"
            borderBottomWidth="1px"
            borderBottomColor="solid.25"
          >
            <Text textStyle="h-s">Add Feedback</Text>
            <ModalCloseButton sx={modal.closeButton} />
          </Flex>
          <Flex py="0px" px="16px" mb="0px" borderBottomWidth="1px" borderBottomColor="solid.25">
            {tabItems.map((item) => (
              <TabItemComponent
                key={item.tab}
                title={item.title}
                tab={item.tab}
                selected={selectedTab === item.tab}
                onSelectTab={() => setSelectedTab(item.tab)}
              />
            ))}
          </Flex>
          <Flex p="20px">
            <ModalInput
              type="text"
              name="feedback"
              placeholder="Write feedback here..."
              value={
                selectedTab === 'correctanswers' ? localFeedback.correct_feedback : localFeedback.incorrect_feedback
              }
              onChange={handleLocalChange}
            />
          </Flex>
          <Flex justify="flex-end" borderTopWidth="1px" borderTopColor="solid.25" p="16px">
            <HStack gap="4px">
              <Button variant="filter" onClick={handleCancel}>
                <Text textStyle="l-s">Cancel</Text>
              </Button>
              <Button
                variant="mono"
                onClick={handleSubmit}
                isDisabled={!localFeedback.correct_feedback && !localFeedback.incorrect_feedback}
              >
                <Text textStyle="l-s">Submit</Text>
              </Button>
            </HStack>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default FeedbackModal
